export const reducerTypes = {
    SET_SELECTED_CURRENCY: "reducer/SET_SELECTED_CURRENCY",
    GET_CURRENCIES: "reducer/GET_CURRENCIES",
    GET_CURRENCY_RATE: "reducer/GET_CURRENCY_RATE",
};

export const sagaTypes = {
    SET_SELECTED_CURRENCY: "saga/SET_SELECTED_CURRENCY",
    GET_CURRENCIES: "saga/GET_CURRENCIES",
    GET_CURRENCY_RATE: "saga/GET_CURRENCY_RATE",
};
